import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [
    "button",
    "selectedProfessionalId",
    "appointmentDate",
    "appointmentTime",
    "appointmentDuration",
    "radioInput",
    "selectedDentist",
    "suggestionOfTimesButton",
    "dateToday"
  ]


  getTimes(date) {
    if(document.getElementsByClassName("selectDentistsAppointment") && this.selectedDentistTarget.value === "") {
      document.getElementsByClassName("selectDentistsAppointment")[1].style.border = "1px solid red"
      return
    }
    if(this.appointmentDurationTarget.value < 5) {
      return swal("Não é possível encontrar horários livres com intervalos de duração inferiores a 5 minutos.", "", "error")
    }
    let selected_professional_id = 0
    if(this.selectedDentistTarget && this.selectedDentistTarget.value != "") {
      selected_professional_id = this.selectedDentistTarget.value
    } else {
      selected_professional_id = this.selectedProfessionalIdTarget.value
    }
    let appointment_date = date
    let appointment_duration = this.appointmentDurationTarget.value

    $.ajax({
      url: "/suggestion_of_times/new",
      method: "GET" ,
      data: { selected_professional_id, appointment_date, appointment_duration },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      beforeSend: function(){
        $("#appointment-spinner").show()
        $(".suggest-times-clock-icon").hide()
        $("#suggest-times-button").css("pointer-events","none")
        $(".suggestion-times-body").hide()
        $(".list-of-times-spinner").show()
        $(".list-of-times-today-button").css("pointer-events","none")
        $(".suggestion-of-time-chevron-button").css("pointer-events","none")
      },
      complete: function(data) {
        $("#appointment-spinner").hide()
        $(".suggest-times-clock-icon").show()
        $("#suggest-times-button").css("pointer-events","auto")
        $(".suggestion-times-body").show()
        $(".list-of-times-spinner").hide()
        $(".list-of-times-today-button").css("pointer-events","auto")
        $(".suggestion-of-time-chevron-button").css("pointer-events","auto")
        $(this.containerTarget).append(data)
      }
    })
  }

  suggestTimes() {
    let date = this.appointmentDateTarget.value
    date = `${date.substring(6,10)}-${date.substring(3,5)}-${date.substring(0,2)}`
    this.getTimes(date)
  }

  getTimesToday(e) {
    let date = moment().format("YYYY-MM-DD")
    e.preventDefault()
    this.getTimes(date)
  }

  getNextTimes(e) {
    let date = moment(`${this.dateTodayTarget.id.substring(6,10)}${this.dateTodayTarget.id.substring(3,5)}${this.dateTodayTarget.id.substring(0,2)}`).add(1, "day").format("YYYY-MM-DD")
    e.preventDefault()
    this.getTimes(date)
  }

  getPreviousTimes(e) {
    let date = moment(`${this.dateTodayTarget.id.substring(6,10)}${this.dateTodayTarget.id.substring(3,5)}${this.dateTodayTarget.id.substring(0,2)}`).subtract(1, "day").format("YYYY-MM-DD")
    e.preventDefault()
    this.getTimes(date)
  }

  getChosenTime() {
    this.appointmentDateTarget.value = this.dateTodayTarget.id
    this.appointmentTimeTarget.value = document.querySelector('input[name="suggestion_of_times"]:checked').id

    this.dispatchInputEvents()
    this.close()
  }


  timeSelected(){
    this.buttonTarget.removeAttribute('disabled')
  }

  dispatchInputEvents(){
    const event = new Event('input', {
        bubbles: true,
        cancelable: true,
    });

    this.appointmentDateTarget.dispatchEvent(event);
    this.appointmentTimeTarget.dispatchEvent(event);
  }

  close() {
    if(document.getElementsByClassName("selectDentistsAppointment").length !== 0) {
      document.getElementsByClassName("selectDentistsAppointment")[1].style.border = "1px solid #dddddd"
    }
    $(".appointmentModal").removeClass("hide")
    $(".new-event-type-radios").removeClass("hide")
    $(".suggestionOfTimesModal").addClass("hide")
  }
}
